<div id="taskUnsavedChangesDialogContainer">
  <mat-dialog-content>
    <div class="unsaved-dialog-content-font">
      <span *ngIf="leavingPage">{{'task.unsavedChanges.leavePage' | blah}}</span><br>
      <span *ngIf="leavingPage">{{'task.unsavedChanges.changesWillBeLost' | blah}}</span>
      <span *ngIf="!leavingPage">{{ customWarning }}</span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div *ngIf="leavingPage">
      <hpo-button id="taskUnsavedChangesStayDialogButton"
        color="primary"
        (click)="stay()">{{ 'task.unsavedChanges.stay' | blah }}</hpo-button>
      <hpo-button id="taskUnsavedChangesLeaveDialogButton"
        color="warn"
        (click)="leave()">{{ 'task.unsavedChanges.leave' | blah }}</hpo-button>
    </div>
    <div *ngIf="!leavingPage">
      <hpo-button id="taskUnsavedChangesStayDialogButton"
        color="primary"
        (click)="stay()">{{ 'default.cancel' | blah }}</hpo-button>
      <hpo-button id="taskUnsavedChangesLeaveDialogButton"
        color="warn"
        (click)="leave()">{{ 'default.continue' | blah }}</hpo-button>
    </div>
  </mat-dialog-actions>
</div>